import React, { FC } from 'react';
import Badge, { BadgeType } from '@zvuk-b2b/react-uikit/ui/Badge';
import { MediaFileTypes } from 'application/pages/types';

import { ADS_PAGE_PATH_ALIAS } from 'application/pages/AdsPage';
import { useLocation } from 'application/providers/RouterProvider';
import { PROMO_LABEL } from '../../MediaListItem/texts';

import styles from './index.module.scss';
import { MediafileType } from '../../types';

interface MediaListItemIconsPromoProps {
  type: MediafileType['type'];
}

const MediaListItemIconsPromo: FC<MediaListItemIconsPromoProps> = (props) => {
  const { type } = props;
  const location = useLocation();

  const promo = type === MediaFileTypes.PROMO || type === MediaFileTypes.VIDEO_PROMO;
  const isPromoBadgePathHide = location.pathname.includes(ADS_PAGE_PATH_ALIAS);
  const withPromo = promo && !isPromoBadgePathHide;

  if (withPromo) {
    return (
      <Badge
        label={PROMO_LABEL}
        type={BadgeType.Neutral2}
        className={styles.Promo}
      />
    );
  }

  return null;
};

export default MediaListItemIconsPromo;
